import GeoTrace from './geo-script.js';

/**
 * class Geo_Loader
 */
class Geo_Loader {
	async load() {
		await new GeoTrace().getLocationCode();
	}
}

new Geo_Loader().load();
